<template>
   <div class="page">
		<div class="boxs">
      <div class="icons" :class="!isPay ? 'on' : ''"></div>
      <div class="info" v-if="!isPay">您取消了支付</div>
    </div>
    <van-popup v-model:show="show" round>
      <div class="pop-box">
				<div class="tit">购买成功!</div>
				<!-- <div class="tit">请前往闲逸查看</div> -->
				
				<div class="btns">
					<div class="btn" @click="closeFn">
						关闭
					</div>
					<!-- <div class="btn reapp" v-if="listData.length" id="downloadButton2">
						前往APP
					</div> -->
				</div>
			</div>
    </van-popup>
   </div>
</template>
<script>
import Vue from 'vue'
import config from '@/config/index'

export default {
  data () {
    return {
      token : '',
      returnApp : false,
      produtId : '',
      playerId : '',
      rechargeType : 0,
      extend : '',
      isPay : true,
      orderId: '',
      show : false,
    }
  },
  created () {
    console.log(this.$route.query)
    const produtId = this.$route.query.id||'';
    const playerId = this.$route.query.playerId || ''
    this.rechargeType = this.$route.query.rechargeType || 0;
    this.extend = this.$route.query.extend || '';
    this.orderId = this.$route.query.orderId || '';


    
    if(produtId){
      this.produtId = produtId;
    }
    if(playerId){
      this.playerId = playerId;
    }
    
    this.token = localStorage.getItem('token_key')
    
    if(produtId){
      this.pays(produtId)
      // this.$toast.loading({
      //   forbidClick: true,
      //   message: '加载中',
      //   duration: 0
      // })
    }
  },
  mounted () {
	  //  this.wxReadyInit()

  },
  methods: {
    async pays(e){
        console.log(e)

					let id = e;
          let appid = localStorage.getItem('appId')
					let d = {
						productId : id,
						xyUserId : this.playerId,
						openId : this.token,
						attach : this.rechargeType,
						extend : this.extend,
            orderId : this.orderId,
            appid
					}

					let res = await this.$api.user.orderCreate(d)
          
					if(res.data.code == 200){
            
            let payInfo = res.data.data;
            if (typeof WeixinJSBridge === 'undefined') { // 微信浏览器内置对象。参考微信官方文档
              if (document.addEventListener) {
                document.addEventListener('WeixinJSBridgeReady', this.wxPay(payInfo), false)
              } else if (document.attachEvent) {
                document.attachEvent('WeixinJSBridgeReady', this.wxPay(payInfo))
                document.attachEvent('onWeixinJSBridgeReady', this.wxPay(payInfo))
              }
            } else {
              console.log('准备调用微信支付')
              this.wxPay(payInfo)
            }
					}else{
						this.$toast(res.data.message)
					}
					// if(this.produtId){
          //   this.$toast.loading({
          //     forbidClick: true,
          //     message: '加载中',
          //     duration: 0
          //   })
					// }
					
				
				
			},
			wxPay(data){
        console.log('调用微信支付WeixinJSBridge')
        WeixinJSBridge.invoke(
          'getBrandWCPayRequest', { // 下面参数内容都是后台返回的
            'appId': data.appId, // 公众号名称，由商户传入
            'timeStamp': String(data.timeStamp), // 时间戳
            'nonceStr': data.nonceStr, // 随机串
            'package': data.packageValue, // 预支付id
            'signType': data.signType, // 微信签名方式
            'paySign': data.paySign // 微信签名
          },
           (res) => {
          // 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
            if (res.err_msg === 'get_brand_wcpay_request:ok') {
              this.openFn()
            } else {
              this.isPay = false;
              // this.$toast('下单失败')
            }
            // this.$toast.clear()
          }
        )
			},
      closeFn(){
        this.show = false;
      },
      openFn(){
        this.show = true;
      },

      wxReadyInit () {
        let appId = localStorage.getItem('appId') || ''
        let Url = window.location.href.split('#')[0]
        this.$api.user.getTicket({ url: encodeURIComponent(Url) }).then(data => {
          this.$wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: appId, // 必填，公众号的唯一标识
            timestamp: data.timestamp, // 必填，生成签名的时间戳
            nonceStr: data.noncestr, // 必填，生成签名的随机串
            signature: data.signature, // 必填，签名
            jsApiList: ['updateAppMessageShareData','updateTimelineShareData'] // 必填，需要使用的JS接口列表
          })
          this.$wx.error(function (res) {
            console.log(res)
          })
        })
        this.$wx.ready(()=>{
         console.log('====ready完成====')

         const title = config.isYp ? '邀朋游戏' : '闲逸游戏';
         const desc = '立即抢购！';
         const imgUrl = 'https://xianyihuyu.oss-cn-shenzhen.aliyuncs.com/tool/xy-help-imgs8.png';
         
          this.$wx.updateAppMessageShareData({ 
            title, // 分享标题
            desc, // 分享描述
            link: config.baseUrl+"/#/activity?id="+this.productId, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl, // 分享图标
            success: function () {
              console.log('====设置分享成功1====')
              // 设置成功

            },
            fial (error) {
              console.log('====设置分享失败1====')
              console.log(error)
            }
          })
          
          this.$wx.updateTimelineShareData({ 
            title, // 分享标题
            link: config.baseUrl+"/#/activity?id="+this.productId, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl, // 分享图标
            success: function () {
              console.log('====设置分享成功2====')
              // 设置成功
            },
            fial (error) {
              console.log('====设置分享失败2====')
              console.log(error)
            }
          })
        })
      }


      

  }
}
</script>
<style lang="less" scoped>
.page{
  width: 100%;
  box-sizing: border-box;
}
.van-popup--center.van-popup--round{
  border-radius: 10px;
}
.boxs{
  width: 100%;
  padding-top: 40px;
  .icons{
    width: 50px;
    height: 50px;
    background:url(~@/assets/images/h5/icon_succ.png) no-repeat;
    background-size: 100% 100%;
    margin: 0 auto 20px;
    &.on{
      background:url(~@/assets/images/h5/icon_fail.png) no-repeat;
      background-size: 100% 100%;
    }
  }
  .info{
    text-align: center;
    font-size: 16px;
    font-weight: bold;
  }
}

.pop-box{
		width: 240px;
		background: #fff;
		border-radius: 10px;
		padding: 12px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		.tit{
			font-size: 15px;
			color: #FE860C;
			line-height: 25px;
		}
		.btns{
			display: flex;
			align-items: center;
			justify-content: center;
			padding-top: 15px;
			.btn{
				width: 90px;
				height: 30px;
				display: flex;
				align-items: center;
				justify-content: center;
				background: linear-gradient(126deg, #FE860C 0%, #FC5F2C 100%);
				border-radius: 15px;
				font-size: 14px;
				color: #fff;
				position: relative;
				
				&.reapp{
					margin-left: 10px;
				}
				button{
					width: 100%;
					height: 100%;
					background: none;
					border: none;
					position: absolute;
					left: 0;
					top: 0;
					&::after{
						border: none;
					}
				}
			}
		}
	}

</style>
